<ng-container *ngIf="type !== NugetType.Libraries && !grid.selectionManager.hasValue()">
    <button [uiAuthorize]="deletePermission"
            [disabled]="!isRemoveAllEnabled"
            (click)="onDeleteInactive()"
            mat-button
            class="action-remove-all-inactive"
            data-cy="nuget-remove-inactive"
            type="button">
        {{ type + '_versions_modal_remove_inactive' | translate }}
    </button>
</ng-container>
<ui-grid #grid
         [data]="data$ | async"
         [selectable]="showDeleteButton && (isDeletePermissionGranted$ | async)"
         [loading]="loading$ | async">

    <ui-grid-header>
        <ui-header-button *ngIf="showDeleteButton"
                          type="action">
            <ng-template>
                <button [disabled]="!allowDelete"
                        [uiAuthorize]="deletePermission"
                        [matTooltip]="type + '_versions_modal_remove' | translate"
                        (click)="onDeleteVersion()"
                        mat-icon-button
                        color="warn">
                    <mat-icon svgIcon="uipath:Delete20px"></mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>

    <ui-grid-column *ngIf="type !== NugetType.Libraries"
                    [title]="type + '_versions_modal_grid_status' | translate"
                    [resizeable]="false"
                    width="20%">
        <ng-template let-entry="data">
            <span translate>
                <ng-container *ngIf="entry?.isActive; else inactiveTmpl">
                    {{ type + '_versions_modal_grid_active' }}
                </ng-container>
                <ng-template #inactiveTmpl>
                    {{ type + '_versions_modal_grid_inactive' }}
                </ng-template>
            </span>
        </ng-template>
    </ui-grid-column>

    <ui-grid-column [title]="type + '_versions_modal_grid_version' | translate"
                    [resizeable]="false"
                    property="version"
                    sort="desc"
                    width="30%">
    </ui-grid-column>

    <ui-grid-column [title]="type + '_versions_modal_grid_published' | translate"
                    [resizeable]="false"
                    width="50%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #publishedFormat
                           [matTooltip]="publishedFormat?.dataset['title']"
                           [date]="entry?.published"
                           contentType="relative"></ui-dateformat>
        </ng-template>
    </ui-grid-column>

    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [matMenuTriggerFor]="menu"
                    [matTooltip]="'global_more_actions_tooltip' | translate"
                    data-cy="grid-action-menu"
                    mat-icon-button
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #menu="matMenu"
                      xPosition="before">
                <button *ngIf="!!entry?.arguments && (
                                !!entry?.arguments.input ||
                                !!entry?.arguments.output
                           )"
                        [uiClickTrack]="'Action: Grid: View Details'"
                        (click)="showInformation.emit(entry)"
                        mat-menu-item
                        data-cy="nuget-changelog-arguments"
                        type="button">
                    <mat-icon svgIcon="uipath:info"></mat-icon>
                    <span>{{type + '_versions_modal_grid_view_info' | translate}}</span>
                </button>
                <!--
                    using *ngIf affects order for keyboard nav [a11y]
                    TODO: remove if fix is merged
                    https://github.com/angular/material2/pull/11720
                -->
                <button *ngIf="true"
                        [uiClickTrack]="'Action: Grid: View Release Notes'"
                        (click)="showReleaseNotes.emit(entry)"
                        mat-menu-item
                        data-cy="nuget-changelog-view"
                        type="button">
                    <mat-icon>subject</mat-icon>
                    <span>{{type + '_versions_modal_grid_view_release_notes' | translate}}</span>
                </button>
                <a *ngIf="isDownloadEnabled"
                   [href]="downloadLink(entry)"
                   [uiClickTrack]="'Action: Grid: Download'"
                   (click)="downloadPackage($event, entry)"
                   mat-menu-item
                   target="_blank">
                    <mat-icon>file_download</mat-icon>
                    <span>{{type + '_versions_modal_grid_download' | translate}}</span>
                </a>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>

    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>

</ui-grid>
